import api from "../api";

const state = {
  showSubscribeNow: false,
  showNewsLetterAlert: false,
  sending: false,
  response: []
};

const mutations = {
  TOGGLE_SHOW_SUBSCRIBE_NOW: (state, payload) => {
    state.showSubscribeNow = payload;
  },

  TOGGLE_ALERT: (state, payload) => {
    state.showNewsLetterAlert = payload;
  },

  TOGGLE_SENDING: (state, payload) => {
    state.sending = payload;
  },
  SET_RESPONSE: (state, payload) => {
    state.response = payload;
  }
};

const actions = {
  subscribe: async ({ commit }, payload) => {
    commit("TOGGLE_SENDING", true);
    let res = await api("post", "/web/message/newsletter", payload);
    commit("TOGGLE_SENDING", false);
    commit("SET_RESPONSE", res);
  },

  toggleSubscribeNow: ({ commit }, payload) => {
    commit("TOGGLE_SHOW_SUBSCRIBE_NOW", payload);
  },

  toggleAlert: ({ commit }, payload) => {
    commit("TOGGLE_ALERT", payload);
  }
};

const getters = {
  showSubscribeNow: state => state.showSubscribeNow,
  response: state => state.response,
  sending: state => state.sending,
  showNewsLetterAlert: state => state.showNewsLetterAlert
};

export default {
  state,
  getters,
  mutations,
  actions
};
